export default __webpack_public_path__ + "static/media/GCC_Playbook3@2x.622dd3d0.jpg";